<template>
  <div class="search">
    <v-text-field outlined label="Поиск" v-model="searchText"></v-text-field>
  </div>
</template>

<script>
export default {
  data: () => ({
    searchText: "",
  }),
  props: ["search"],
  watch: {
    searchText(val) {
      this.search(val);
    },
  },
};
</script>

<style lang="scss">
.search {
  padding: 3px 5px;
  border: none;
  margin-top: -20px !important;
  margin-bottom: 20px !important;
  & .v-text-field__slot {
    border: none;
  }
}
</style>
